import React from 'react';
import { BLOG_POSTS, AREAS } from '../mock';
import { ArrowRight, MapPin, Calendar, Clock } from 'lucide-react';
import { Button } from './ui/button';

export const Areas = () => (
  <section className="section bg-white">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="max-w-3xl mb-10">
        <span className="text-xs font-bold uppercase tracking-[0.25em] gold-text">Areas we serve</span>
        <h2 className="mt-3 text-4xl md:text-5xl font-extrabold navy-text leading-tight">
          Headquartered in New York. Shipping coast to coast.
        </h2>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
        {AREAS.map((a, i) => (
          <article key={i} className="card-lift group bg-[#F7F9FC] border border-[#E5EAF2] rounded-2xl p-6 flex gap-5 items-start">
            <div className="w-12 h-12 rounded-xl bg-white border border-[#E5EAF2] flex items-center justify-center shrink-0 group-hover:bg-[#0A1628] transition-colors">
              <MapPin className="w-5 h-5 text-[#D4A24C]" />
            </div>
            <div className="flex-1">
              <h3 className="text-xl font-extrabold navy-text">{a.state} Auto Transport</h3>
              <p className="mt-2 text-sm text-[#4A5A72]">{a.copy}</p>
              <a href="/#quote" className="inline-flex items-center gap-1 mt-3 text-sm font-bold text-[#0A1628] hover:gold-text transition-colors">
                Learn more <ArrowRight className="w-4 h-4" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

const BlogSection = () => (
  <section className="section bg-[#F7F9FC]">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <div className="flex flex-col md:flex-row md:items-end md:justify-between mb-10 gap-4">
        <div className="max-w-2xl">
          <span className="text-xs font-bold uppercase tracking-[0.25em] gold-text">From the blog</span>
          <h2 className="mt-3 text-4xl md:text-5xl font-extrabold navy-text leading-tight">Guides, tips & industry updates.</h2>
        </div>
        <Button variant="outline" className="font-semibold hover:bg-[#0A1628] hover:text-white hover:border-[#0A1628]">View all articles</Button>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
        {BLOG_POSTS.map((p, i) => (
          <article key={i} className="card-lift group bg-white rounded-2xl overflow-hidden border border-[#E5EAF2]">
            <div className="aspect-[16/10] overflow-hidden">
              <img src={p.image} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" />
            </div>
            <div className="p-6">
              <div className="flex items-center gap-4 text-xs text-[#4A5A72] mb-3">
                <span className="flex items-center gap-1"><Calendar className="w-3.5 h-3.5" /> {p.date}</span>
                <span className="flex items-center gap-1"><Clock className="w-3.5 h-3.5" /> {p.readTime}</span>
              </div>
              <h3 className="text-lg font-extrabold navy-text leading-snug mb-2 group-hover:gold-text transition-colors">{p.title}</h3>
              <p className="text-sm text-[#4A5A72] mb-4">{p.excerpt}</p>
              <span className="inline-flex items-center gap-1 text-sm font-bold text-[#0A1628]">Read more <ArrowRight className="w-4 h-4" /></span>
            </div>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default BlogSection;
